import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { HttpHelper } from '@app/common/http-helper';
import { SPHomeContext } from '@app/models/sphome-context';
import { CacheService } from '@app/services/cache.service';
import { Environment } from '@environments/interface.environment';
import { Observable } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SphomeService {

  constructor(private http: HttpClient,
              @Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              private cache: CacheService,
              private httpHelper: HttpHelper) { }

  private getSPHomeContext$: Observable<SPHomeContext>;
  public useCache = true;
  private cacheKey = 'SphomeService-getSPHomeContext';

  getSPHomeContext(): Observable<SPHomeContext> {
    if (!this.getSPHomeContext$) {
      const httpParams = new HttpParams().append('$expand', 'Token,Payload');
      this.getSPHomeContext$ = this.http
        .get<SPHomeContext>(`${this.environment.tenantHostUrl}/_api/sphomeservice/context`, { params: httpParams })
        .pipe(
          tap(data => {
            this.useCache && this.cache.set(this.cacheKey, data);
          }),
          catchError(this.httpHelper.handleError<SPHomeContext>({ operation: 'getSPHomeContext', cacheKey: this.cacheKey })),
          shareReplay({ bufferSize: 1, refCount: true }));
    }
    return this.getSPHomeContext$;
  }
}
